import { useQuery } from "@tanstack/react-query";

import type { TemplateLibraryEntryTypeEnum } from "@performyard/service-contracts";

import { fetchTemplateLibraryEntries, fetchTemplateLibraryEntry } from "../../../api/services/defs/template-library";

export const TEMPLATE_LIBRARY_KEYS = {
	all: ["template-library"] as const,
	list: (type?: TemplateLibraryEntryTypeEnum) => [...TEMPLATE_LIBRARY_KEYS.all, "list", type ?? "all"] as const,
	detail: (id: string) => [...TEMPLATE_LIBRARY_KEYS.all, "detail", id] as const,
};

export const useTemplateLibraryEntries = (type?: TemplateLibraryEntryTypeEnum) =>
	useQuery({
		queryKey: TEMPLATE_LIBRARY_KEYS.list(type),
		queryFn: () => fetchTemplateLibraryEntries(type),
	});

export const useTemplateLibraryEntry = (entryId: string | null) =>
	useQuery({
		queryKey: entryId ? TEMPLATE_LIBRARY_KEYS.detail(entryId) : TEMPLATE_LIBRARY_KEYS.detail("none"),
		queryFn: () => fetchTemplateLibraryEntry(entryId as string),
		enabled: !!entryId,
	});
